import * as yup from 'yup';

import { formatMessage } from 'utils/messages/utils';

export default yup.object().shape({
  territoryGroup: yup
    .object()
    .test('territoryGroup', { value: formatMessage('TERRITORY_GROUP_REQUIRED') }, (val) => !!val.value)
});
